import { render, staticRenderFns } from "./admin-calendar-events.vue?vue&type=template&id=3f803f7e&scoped=true&"
import script from "./admin-calendar-events.vue?vue&type=script&lang=js&"
export * from "./admin-calendar-events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f803f7e",
  null
  
)

export default component.exports